"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactLazyComponent = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var ModuleRegistry_1 = require("./ModuleRegistry");
var ReactModuleContainerErrors_1 = require("./ReactModuleContainerErrors");
var tag_appender_1 = require("./tag-appender");
var ReactLazyComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ReactLazyComponent, _super);
    function ReactLazyComponent(props, manifest) {
        var _this = _super.call(this, props, manifest) || this;
        _this.manifest = manifest;
        _this.state = { component: null };
        _this.manifest = manifest;
        return _this;
    }
    ReactLazyComponent.prototype.componentWillMount = function () {
        var _this = this;
        (0, ModuleRegistry_1.getModuleRegistry)().notifyListeners('reactModuleContainer.componentStartLoading', this.manifest.component);
        var prepare = this.manifest.prepare ? function () { return _this.manifest.prepare(); } : function () { return undefined; };
        var filesAppenderPromise = (0, tag_appender_1.filesAppender)(this.manifest.files, this.manifest.crossorigin).then(prepare);
        var resolvePromise = this.manifest.resolve ? this.manifest.resolve() : Promise.resolve({});
        this.resourceLoader = Promise.all([resolvePromise, filesAppenderPromise])
            .then(function (_a) {
            var _b = tslib_1.__read(_a, 1), resolvedData = _b[0];
            _this.resolvedData = resolvedData;
            (0, ModuleRegistry_1.getModuleRegistry)().notifyListeners('reactModuleContainer.componentReady', _this.manifest.component);
        })
            .catch(function (err) {
            (0, ModuleRegistry_1.getModuleRegistry)().notifyListeners('reactModuleContainer.error', new ReactModuleContainerErrors_1.LazyComponentLoadingError(_this.manifest.component, err));
        });
    };
    ReactLazyComponent.prototype.componentDidMount = function () {
        var _this = this;
        this.resourceLoader.then(function () {
            var component = (0, ModuleRegistry_1.getModuleRegistry)().component(_this.manifest.component);
            _this.setState({ component: component });
        });
    };
    ReactLazyComponent.prototype.componentWillUnmount = function () {
        if (this.manifest.unloadStylesOnDestroy !== false) {
            (0, tag_appender_1.unloadStyles)(document, this.manifest.files);
        }
        (0, ModuleRegistry_1.getModuleRegistry)().notifyListeners('reactModuleContainer.componentWillUnmount', this.manifest.component);
    };
    ReactLazyComponent.prototype.render = function () {
        var Component = this.state.component;
        if (!Component) {
            return null;
        }
        return React.createElement(Component, tslib_1.__assign({}, this.props, this.resolvedData));
    };
    return ReactLazyComponent;
}(React.Component));
exports.ReactLazyComponent = ReactLazyComponent;
//# sourceMappingURL=ReactLazyComponent.js.map